import { goRequest } from '../utils/httpClientTs';
import {
  PEOReportListResponse,
  ReportMetadata,
  ExecuteReportRequest,
  ExecuteReportResponse,
  EmailExportResponse,
} from '../types/peoReports';

export const getPEOReportList = async (): Promise<PEOReportListResponse> => {
  return goRequest<PEOReportListResponse>({
    url: '/api/reports',
    method: 'GET',
  });
};

export const getPEOReportMetadata = async (
  reportId: string
): Promise<ReportMetadata> => {
  return goRequest<ReportMetadata>({
    url: `/api/reports/${reportId}`,
    method: 'GET',
  });
};

export const executePEOReport = async (
  reportId: string,
  params: ExecuteReportRequest
): Promise<ExecuteReportResponse> => {
  return goRequest<ExecuteReportResponse>({
    url: `/api/reports/${reportId}/execute`,
    method: 'POST',
    data: params,
  });
};

export const exportPEOReportEmails = async (
  reportId: string,
  params: Omit<ExecuteReportRequest, 'format'>
): Promise<EmailExportResponse> => {
  return goRequest<EmailExportResponse>({
    url: `/api/reports/${reportId}/execute`,
    method: 'POST',
    data: { ...params, format: 'emails' },
  });
};
